$(function() {
    if(variablesMap && variablesMap.size > 0){
        var $textNodes = $('*')
            .contents()
            .filter(function(i, el) {
                return el.nodeType === 3; //Node.TEXT_NODE
            });
        var $textNodes = $.merge($textNodes, $('*:not(:has(*)), p, article, div' ));
        $textNodes.each(function(i, el) {
                var $el = $(el);
                var text = $el.html();
                if(text){
                    var tempText = text;
                    variablesMap.forEach(function(value, key, map){
                        var htmlValue = $('<span>').text(value).html();
                        text = text.split("{{"+key+"}}").join(htmlValue);
                    });
                    while(text !== tempText){
                        tempText = text;
                        $el.html(text);
                        variablesMap.forEach(function(value, key, map){
                            var htmlValue = $('<span>').text(value).html();
                            text = text.split("{{"+key+"}}").join(htmlValue);
                        });
                    }
                }
         });
    }
});
